import sortByKey from 'utils/sortByKey';
import { NUTRITION_TYPE } from '../../nutrition-label/components/utils/Constants';
import _ from 'lodash';

const SPECIAL_NUTRIENT = [
  'Fat, Total',
  'Cholesterol',
  'Sodium',
  'Carbohydrate, total',
  'Protein, Total',
];

export const getNutrientList = (nutritionFactProperties) => {
  let nutrientFormatType = [];
  nutritionFactProperties.forEach((item) => {
    const { nutritionTypeCode } = item;

    const filteredNutritionTypeCode = SPECIAL_NUTRIENT.find((item) =>
      nutritionTypeCode
        ?.toLocaleLowerCase()
        ?.includes(item?.toLocaleLowerCase())
    );

    const typeCode = filteredNutritionTypeCode || nutritionTypeCode;

    if (NUTRITION_TYPE[typeCode]) {
      nutrientFormatType.push({
        ...NUTRITION_TYPE[typeCode],
        ...item,
      });
    }
  });

  nutrientFormatType = _.uniqBy(nutrientFormatType, 'nutritionName');

  return sortByKey(nutrientFormatType, 'index');
};

export const compareOverlayNutrients = ({ originValue, overlayValue }) => {
  const cloneOverlayValue = _.cloneDeep(overlayValue);
  overlayValue?.forEach((nutrient, index) => {
    const isEqual = originValue?.some(
      (item) => JSON.stringify(item) === JSON.stringify(nutrient)
    );
    if (!isEqual) {
      cloneOverlayValue[index] = { ...nutrient, hightLightText: '#e6f7ff' };
    }
  });
  return cloneOverlayValue;
};

export const compareOriginNutrients = ({ originValue, overlayValue }) => {
  const cloneOriginValue = _.cloneDeep(originValue);
  originValue?.forEach((nutrient, index) => {
    const hasNutrient = overlayValue?.find(
      (item) => item?.path === nutrient?.path
    );

    if (hasNutrient) {
      if (JSON.stringify(hasNutrient) === JSON.stringify(nutrient)) {
        cloneOriginValue[index] = { ...nutrient, hightLightText: '' };
      } else {
        cloneOriginValue[index] = { ...nutrient, hightLightText: '#e6f7ff' };
      }
    } else {
      cloneOriginValue[index] = { ...nutrient, hightLightText: '#ffa39e' };
    }
  });
  return cloneOriginValue;
};

export const compareDietaryIngredients = ({ originValue, overlayValue }) => {
  const cloneOriginValue = _.cloneDeep(originValue);
  originValue?.forEach((nutrient, index) => {
    const hasNutrient = overlayValue?.find((item) => {
      return item?.path === nutrient?.path;
    });

    if (hasNutrient) {
      if (JSON.stringify(hasNutrient) === JSON.stringify(nutrient)) {
        cloneOriginValue[index] = { ...nutrient, hightLightText: '' };
      } else {
        cloneOriginValue[index] = { ...nutrient, hightLightText: '#e6f7ff' };
      }
    } else {
      cloneOriginValue[index] = { ...nutrient, hightLightText: '#ffa39e' };
    }
  });
  return cloneOriginValue;
};

export const addOriginData = ({ originValue, currentValue }) => {
  const addOriginValue = currentValue?.map((item) => {
    const originData = originValue?.find(
      (element) => element?.path === item?.path
    );
    return {
      ...item,
      originData: originData || null,
    };
  });
  return addOriginValue;
};
